import axiosInstance from '../axiosInstance';

export const checkOrganizationNameExists = async (name, excludeId = null) => {
  try {
    const payload = { name };
    if (excludeId) payload.excludeId = excludeId;
    await axiosInstance.post('/api/v1/organizations/check-name', payload, {
      withCredentials: true,
    });
    return false;
  } catch (error) {
    if (error.response?.status === 409) {
      return true;
    }
    return false;
  }
};
